// DataTags
// The datatag regex match is mainly \{\[[^\{\[\]\}]*\]\} to detect any text wrapped in "{[ ]}".
// The negative lookahead before it is repeating parts of it multiple times to detect any HTML tags,
// which we want to exclude from datatag matching.
// eslint-disable-next-line max-len
var DATA_TAG_REG_EXP = /(?!\{\[[^\{\[\]\}]*<[^\{\[\]\}]*>[^\{\[\]\}]*\]\})\{\[[^\{\[\]\}]*\]\}/g;

export default DATA_TAG_REG_EXP;
export { DATA_TAG_REG_EXP };
//# sourceMappingURL=index.js.map
